import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarBoarding from "../../../components/SidebarDashboard";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

//redux
import {
  deleteHoliday,
  editHoliday,
  getHolidays,
  saveHoliday,
} from "../../../redux/holidays/actions";
import { getOrgs } from "../../../redux/organization/actions";
import { withWidth } from "@material-ui/core";

const Holidays = (props) => {
  const schema = Yup.object().shape({
    empresa: Yup.string().ensure().required("**Campo requerido"),
    anio: Yup.number().required("**Campo requerido"),
    fecha_inicio: Yup.string().ensure().required("**Campo requerido"),
    fecha_fin: Yup.string().ensure().required("**Campo requerido"),
    // hora_inicio: Yup.string().required("**Campo requerido"),
    // hora_fin: Yup.string().required("**Campo requerido"),
    // duracion_horas: Yup.number().required("**Campo requerido"),
    // duracion_dias: Yup.number().required("**Campo requerido"),
    // fraccion_dia: Yup.string().ensure().required("**Campo requerido"),
  });

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);

  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [_empresa, setEmpresa] = useState("");
  const [_fecha_inicio, setFechaInicio] = useState(
    moment().format("YYYY") + "-01-01"
  );
  const [_fecha_fin, setFechaFin] = useState(
    moment().format("YYYY") + "-12-31"
  );
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "empresa",
    desc: "Empresa",
  });
  const fecha = new Date();
  var n = fecha.getFullYear();
  const [_anio, setAnio] = useState(n);
  const [tipoBusquedaAnio, setTipoBusquedaAnio] = useState({
    id: "anio",
    desc: "Año",
  });

  const dispatch = useDispatch();
  const {
    loaderHoliday,
    holiday,
    holidaysFail,
    holidayAnio,
    saveLoaderHoliday,
    holidayFormError,
  } = useSelector((store) => store.holiday);

  const data = useSelector((store) => store.orgs.orgs);
  const loadingOrgs = useSelector((store) => store.orgs.loading);
  const [isOrgSelect, setIsOrgSelect] = useState(false);

  const pages = Math.ceil(holiday ? holiday.count / limit : 0);

  //   Datos de CustomTable
  const columns = [
    // {
    //   Header: "Empresa",
    //   accessor: "list_empresa[0].nombre",
    // },
    {
      Header: "Año",
      accessor: "anio",
    },
    {
      Header: "Fecha de Inicio",
      accessor: "fecha_inicio",
    },
    {
      Header: "Fecha Finalización",
      accessor: "fecha_fin",
    },
    {
      Header: "Hora de Inicio",
      accessor: "hora_inicio",
    },
    {
      Header: "Hora Finalización",
      accessor: "hora_fin",
    },
    {
      Header: "Duración de Horas",
      accessor: "duracion_horas",
    },
    {
      Header: "Duración de Días",
      accessor: "duracion_dias",
    },
    {
      Header: "Fracción de Día",
      accessor: "fraccion_dia",
    },

    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex button-group " role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];
  // const filters = [
  //   { id: "empresa", desc: "Empresa" },
  //   { id: "anio", desc: "Año" },
  // ];

  const _getHoliday = (
    offs = offset,
    lim = limit,
    empre = _empresa,
    fecha_de_inicio = _fecha_inicio,
    fecha_de_fin = _fecha_fin
  ) =>
    dispatch(
      getHolidays({
        offset: offs,
        limit: lim,
        empresa: empre,
        fecha_inicio: fecha_de_inicio,
        fecha_fin: fecha_de_fin,

        // anio: ani,
        // tipo_busqueda: tipoBusqueda.id,

        //   filter:

        //     tipoBusqueda.id === "fecha_creacion"
        //       ? filt !== ""
        //         ? !isNaN(filt)
        //           ? filt
        //           : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
        //               8
        //             )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
        //               4
        //             )}-${filt.charAt(0)}${filt.charAt(1)}`
        //         : filt
        //       : filt,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteHoliday(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getHoliday(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    if (_empresa !== "") {
      setIsOrgSelect(true);
    } else {
      setIsOrgSelect(false);
    }
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getHoliday(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    // debugger;
    // console.log(req);
    // if (req.empresa) req.empresa = parseInt(req.empresa);

    // const exist = holiday.data.find((e) => e.empresa === req.empresa);
    // if (exist) {
    //   toastr.info("La empresa ya existe.");
    //   return;
    // }
    if (!edit) {
      dispatch(saveHoliday(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editHoliday(req, index, setShowFormModal));
    }
  };
  useEffect(() => {
    _getHoliday();
    dispatch(getOrgs(parseInt(2)));
  }, []);
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarBoarding show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">Dias Feriados</h5>
            {/* <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col> */}
            <Col xs="auto">
              <ButtonGroup>
                {/* <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button> */}
                <Button
                  variant="light"
                  size="sm"
                  className="rounded-pill"
                  onClick={() => onAdd()}
                >
                  <i className="material-icons">add</i>
                </Button>
                {/* <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger> */}
              </ButtonGroup>
            </Col>
            {/* </Form.Row>
            </Form>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusquedaAnio.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusquedaAnio(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form> */}
          </div>
          <div className="px-2">
            <hr />
          </div>
          <div className="d-flex justify-content-around">
            <Form.Group as={Col} className="mb-md-1">
              <Row>
                <Form.Label column sm={4}>
                  Empresa:
                </Form.Label>
                <Col sm={8}>
                  <Row className="d-flex flex-wrap justify-content-start align-items-center">
                    <Col sm={loadingOrgs ? "10" : "12"}>
                      <Form.Control
                        as="select"
                        id="empresa"
                        name="empresa"
                        className="col rounded-pill"
                        defaultValue=""
                        disabled={loadingOrgs}
                        onChange={(e) => {
                          e.preventDefault();
                          setEmpresa(e.currentTarget.value);
                          debugger;
                          _getHoliday(
                            offset,
                            limit,

                            // filter,
                            e.currentTarget.value,
                            _fecha_inicio,
                            _fecha_fin
                          );
                        }}
                      >
                        <option
                          className="text-muted"
                          value=""
                          selected
                          disabled
                        >
                          Seleccionar Empresa
                        </option>
                        {data.length > 0 &&
                          data.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                      </Form.Control>
                    </Col>
                    {loadingOrgs ? (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </Form.Group>
            {/* <Form.Group as={Col} md={3} className="mb-md-1">
            <Row>
              <Form.Label column sm={3}>
                Año
              </Form.Label>
              <Col sm={9}>
                <Row className="d-flex flex-wrap justify-content-start align-items-center">
                  <Col sm={loaderHoliday ? "10" : "12"}>
                    <Form.Control
                      as="select"
                      id="anio"
                      name="anio"
                      className="col rounded-pill"
                      value={_anio}
                      disabled={!holidayAnio ||(holidayAnio && holidayAnio.data.length === 0)}
                      onChange={(e) => {
                        
                         e.preventDefault();
                        setAnio(e.currentTarget.value);
                        _getHoliday(
                          offset,
                          limit,
                          e.currentTarget.value,
                          _empresa,
                        );
                        
                      }}
                    >
                      <option className="text-muted" value="" selected disabled>
                        Selecionar Año
                      </option>
                      {holidayAnio &&
                        holidayAnio.data.map((item) => (
                          <option key={item.id} value={item.anio}>
                            {item.anio}
                          </option>
                        ))}
                    </Form.Control>
                  </Col>
                  {loaderHoliday ? (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  ) : null}
                </Row>
              </Col>
            </Row>
          </Form.Group> */}
            <Form.Group as={Col} className="mb-md-1">
              <Row>
                <Form.Label column sm={4}>
                  Fecha inicio:
                </Form.Label>
                <Col sm={8}>
                  <Row className="d-flex flex-wrap justify-content-start align-items-center">
                    <Col sm={loadingOrgs ? "10" : "12"}>
                      <Form.Control
                        type="date"
                        id="fecha_de_inicio"
                        name="fecha_de_inicio"
                        className="col rounded-pill"
                        defaultValue={moment().format("YYYY") + "-01-01"}
                        disabled={loadingOrgs}
                        onChange={(e) => {
                          e.preventDefault();
                          setAnio(e.currentTarget.value);
                          _getHoliday(
                            offset,
                            limit,
                            _empresa,
                            e.currentTarget.value,
                            _fecha_fin
                          );
                        }}
                      ></Form.Control>
                    </Col>
                    {loadingOrgs ? (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group as={Col} className="mb-md-1">
              <Row>
                <Form.Label column sm={4}>
                  Fecha Fin:
                </Form.Label>
                <Col sm={8}>
                  <Row className="d-flex flex-wrap justify-content-start align-items-center">
                    <Col sm={loadingOrgs ? "10" : "12"}>
                      <Form.Control
                        type="date"
                        id="fecha_de_fin"
                        name="fecha_de_fin"
                        className="col rounded-pill"
                        defaultValue={moment().format("YYYY") + "-12-31"}
                        disabled={loadingOrgs}
                        onChange={(e) => {
                          e.preventDefault();
                          setEmpresa(e.currentTarget.value);
                          _getHoliday(
                            offset,
                            limit,
                            _empresa,
                            _fecha_inicio,
                            // filter,
                            e.currentTarget.value
                          );
                        }}
                      ></Form.Control>
                    </Col>
                    {loadingOrgs ? (
                      <Col sm={1}>
                        <Spinner animation="border" size="sm" />
                      </Col>
                    ) : null}
                  </Row>
                </Col>
              </Row>
            </Form.Group>
          </div>
          {!!holidaysFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {holidaysFail}
            </Alert>
          )}
          {loaderHoliday ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : holiday != null && holiday.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={holiday.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={holiday.count}
                pages={pages}
                pagFunc={_getHoliday}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay fechas, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              empresa: edit ? editItem.empresa : _empresa,
              anio: edit ? editItem.anio : "",
              fecha_inicio: edit ? editItem.fecha_inicio : "",
              fecha_fin: edit ? editItem.fecha_fin : "",
              hora_inicio: edit ? editItem.hora_inicio : "",
              hora_fin: edit ? editItem.hora_fin : "",
              duracion_horas: edit ? editItem.duracion_horas : "0",
              duracion_dias: edit ? editItem.duracion_dias : "0",
              fraccion_dia: edit ? editItem.fraccion_dia : "0",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar Día Feriado" : "Crear Día Feriado"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {holidayFormError && typeof holidayFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {holidayFormError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1  ">
                    <Form.Label column sm="12" md="12">
                      Empresa
                    </Form.Label>

                    <Row className="d-flex flex-wrap justify-content-start align-items-center">
                      <Col sm={loadingOrgs ? "12" : "12"}>
                        <Form.Control
                          as="select"
                          id="empresa"
                          name="empresa"
                          disabled
                          className="col rounded-pill"
                          isInvalid={touched.empresa && errors.empresa}
                          isValid={touched.empresa && !errors.empresa}
                          onBlur={handleBlur("empresa")}
                          value={values.empresa}
                          // defaultValue={empresa}

                          onChange={(e) => {
                            //   dispatch(
                            //     getPeriodicityByOrg({
                            //       tipo_busqueda: "empresa__id",
                            //       filter: parseInt(e.currentTarget.value),
                            //     //   tipo_busqueda_2: "anio",
                            //     //   filter_2: parseInt(n),
                            //     })
                            //   );
                            // dispatch(
                            //   getPeriodicityByOrg({
                            //     tipo_busqueda: "empresa__id",
                            //     filter: parseInt(e.currentTarget.value),
                            //   })
                            // );
                            if (e.currentTarget.value !== "") {
                              setIsOrgSelect(true);
                            } else {
                              setIsOrgSelect(false);
                            }
                            handleChange(e);
                          }}
                        >
                          <option
                            className="text-muted"
                            value=""
                            selected
                            disabled
                          >
                            Selecionar Empresa
                          </option>
                          {data.length > 0 &&
                            data.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.nombre}
                              </option>
                            ))}
                        </Form.Control>
                      </Col>
                      {loadingOrgs ? (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      ) : null}
                    </Row>
                    {touched.empresa && errors.empresa && (
                      <Col>
                        <small className="text-danger">{errors.empresa}</small>
                      </Col>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Año
                    </Form.Label>
                    <Form.Control
                      name="anio"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.anio}
                      placeholder="Año"
                      onBlur={handleBlur("anio")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.anio && !!errors.anio}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.anio}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.anio ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.anio.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Fecha de Inicio
                    </Form.Label>
                    <Form.Control
                      name="fecha_inicio"
                      className="rounded-pill"
                      required
                      type="date"
                      value={values.fecha_inicio}
                      onBlur={handleBlur("fecha_inicio")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.fecha_inicio && !!errors.fecha_inicio}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.fecha_inicio}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.fecha_inicio ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.fecha_inicio.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Fecha de Finalización
                    </Form.Label>
                    <Form.Control
                      name="fecha_fin"
                      className="rounded-pill"
                      required
                      type="date"
                      value={values.fecha_fin}
                      onBlur={handleBlur("fecha_fin")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.fecha_fin && !!errors.fecha_fin}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.fecha_fin}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.fecha_fin ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.fecha_fin.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Hora de Inicio
                    </Form.Label>
                    <Form.Control
                      name="hora_inicio"
                      className="rounded-pill"
                      type="time"
                      value={values.hora_inicio}
                      onBlur={handleBlur("hora_inicio")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.hora_inicio && !!errors.hora_inicio}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.hora_inicio}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.hora_inicio ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.hora_inicio.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Hora de Finalización
                    </Form.Label>
                    <Form.Control
                      name="hora_fin"
                      className="rounded-pill"
                      type="time"
                      value={values.hora_fin}
                      onBlur={handleBlur("hora_fin")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.hora_fin && !!errors.hora_fin}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.hora_fin}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.hora_fin ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.hora_fin.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  {/* <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Duración de Horas
                    </Form.Label>
                    <Form.Control
                      name="duracion_horas"
                      className="rounded-pill"
                      placeholder="Duración de Horas"
                      type="number"
                      value={values.duracion_horas}
                      onBlur={handleBlur("duracion_horas")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.duracion_horas && !!errors.duracion_horas
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.duracion_horas}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.duracion_horas ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.duracion_horas.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Duración de Días
                    </Form.Label>
                    <Form.Control
                      name="duracion_dias"
                      className="rounded-pill"
                      placeholder="Duración de Días"
                      type="number"
                      value={values.duracion_dias}
                      onBlur={handleBlur("duracion_dias")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={
                        touched.duracion_dias && !!errors.duracion_dias
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.duracion_dias}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.duracion_dias ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.duracion_dias.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Fracción de Día
                    </Form.Label>
                    <Form.Control
                      name="fraccion_dia"
                      className="rounded-pill"
                      placeholder="Fracción de días"
                      type="number"
                      value={values.fraccion_dia}
                      onBlur={handleBlur("fraccion_dia")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.fraccion_dia && !!errors.fraccion_dia}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.fraccion_dia}
                    </Form.Control.Feedback>
                    {holidayFormError &&
                    typeof holidayFormError === "object" &&
                    holidayFormError.fraccion_dia ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {holidayFormError.fraccion_dia.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group> */}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderHoliday}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderHoliday && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default Holidays;
